/*eslint-disable */

import axios from 'axios';
import {
  mapGetters
} from 'vuex';
import toast from '@/services/toast';

const $ = window.jQuery = require('jquery'); 


export default {
  name: 'leave-list-of-emplooyee',
  components: {},
  props: [],
  data () {
    return {
      employeeLeaveList:null,
      employeeLeaveListResults:[],
      nextStep:'',
      loadmoreData: {},
      userLoading: false,
      submitted:false,
      countryList:[],
      removeUserFromOurList:false,
      removeUserId:'',
      nextPageUrl:null
    }
  },
  computed: {
  ...mapGetters([
    'employeeLeaveListGetters',
  ]),
  getEmployeeLeaveListFun(){
   this.employeeLeaveList = this.$store.getters.employeeLeaveListGetters.data
   return 
  },
  SetIntialStatus() {
    if (this.employeeLeaveList) {
      this.nextStep = this.employeeLeaveList.next
      this.nextPageUrl = this.employeeLeaveList.next
      this.employeeLeaveListResults = this.employeeLeaveList.results
    }
  },
  },
  mounted () {
    this.getEmployeeLeaveListFun
    this.SetIntialStatus 
  },
  methods: {
    getRemoveListAgain() {
      this.$store.dispatch('geEmployeeLeaveListFun').then((res) => {
        this.employeeLeaveList = res.data.data
      }).catch((err) => {
      })
    },
    showRemovedModalFun(id){
      $("body").addClass("body_right_scroll_remove");
      this.removeUserFromOurList = true
      this.removeUserId = id
    },
    removeModalItemConfirmFun(){
      this.$store.dispatch('removeSaOrgUserFun', {
        id: this.removeUserId,
      })
      .then((res) => {
        if (res.status == '200') {      
          toast.success(res.data.msg); 
          $("body").removeClass("body_right_scroll_remove");
          this.removeUserFromOurList = false
          this.removeUserId = ''
          this.getRemoveListAgain()
        }
      }).catch((err) => {
        toast.error(err.data.user_msg);  
      })
    return;
    },
    closeRemoveItemModalFun(){
      $("body").removeClass("body_right_scroll_remove");
      this.removeUserFromOurList = false
      this.taskDeleteId = ''
    },
    showLoadMoreDataFun(url) {
      this.userLoading = true
      axios.get(url).then((response) => {
          this.loadmoreData = response.data
          this.nextStep = this.loadmoreData.data.next
          this.$set(this.employeeLeaveListResults, 'next', this.nextStep)
          if (this.loadmoreData != undefined) {
            for (var i = 0; i < this.loadmoreData.data.results.length; i++) {
              this.employeeLeaveListResults.push(this.loadmoreData.data.results[i]);
              this.userLoading = false
            }
          }
        });
    },
  },
  watch:{
    nextStep(old_val, new_val){
      if(new_val != ''){
        this.nextPageUrl = new_val
      }
    },
    getEmployeeLeaveListFun(){
      return  this.$store.getters.employeeLeaveListGetters
    },
    SetIntialStatus() {
      if (this.employeeLeaveList) {
        this.employeeLeaveListResults = this.employeeLeaveList.results
      }
    },
  },
  beforeCreate: function() {
  },
  beforeRouteLeave: function(to, from, next) {
    $("body").removeClass("body_right_scroll_remove");
    next();
  },
}